<template>
    <div :class="containerClassName">
        <p :class="className" v-text="timeDifference"></p>
    </div>
</template>

<script>
import TimeActivity from '@spa/apps/trustup-pro-planning-js/models/TimeActivity';
export default {
    props: {
        containerClassName: {
            type: String,
            default: 'w-[100px]',
        },
        className: {
            type: String,
            default: 'text-2xl font-semibold text-gray-800'
        },
        activity: {
            type: Object,
            required: true
        },
        format: {
            type: String,
            default: 'HH:mm:ss'
        }
    },
    data() {
        return {
            timeDifference: null,
            timeDifferenceInterval: null
        }
    },
    watch: {
        'activity.updated_at'() {
            console.log('Init Live Timer from watcher');
            this.init();
        },
        'activity.status'() {
            console.log('Init Live Timer from watcher');
            this.init();
        }
    },
    methods:
    {
        getStart() {
            return this.start;
        },

        getEnd() {
            if ( this.end ) {
                return this.end;
            }
            
            if ( this.inProgress ) {
                return null;
            }

            return this.start;
        },

        init() 
        {    
            if ( this.timeDifferenceInterval ) {
                clearInterval(this.timeDifferenceInterval);
            }
            this.timeDifferenceInterval = null;

            if ( this.activity.status !== 'in_progress' ) {
                this.timeDifference = this.$moment().startOf('day').seconds(this.activity.live_timer.duration).format(this.format, { trim: false });
                return;
            }
            
            this.timeDifference = this.getLiveTimeDifference();
            this.timeDifferenceInterval = setInterval(() => this.timeDifference = this.getLiveTimeDifference(), 1000);
        },

        /**
         * We need to add the difference between the current time and the time the live timer was loaded
         * to the duration of the live timer; then format it to display it.
         */
        getLiveTimeDifference()
        {
            const differenceInSeconds = this.$moment().diff(this.$moment(this.activity.live_timer.loaded_at), 'seconds');
            const duration = this.activity.live_timer.duration + differenceInSeconds;
            return this.$moment().startOf('day').seconds(duration).format(this.format, { trim: false });
        }
    },
    created() {
        this.init();
    }
}
</script>